import { render } from "./IconSort.vue?vue&type=template&id=3f5c739c"
import script from "./IconSort.vue?vue&type=script&lang=js"
export * from "./IconSort.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__